import { VStack } from '@chakra-ui/react'
import SvgIcon from 'components/SvgIcon'

const GlobalSpinner = () => {
  return (
    <VStack position="fixed" height="100vh" width="100vw" top="0" left={{ base: 0, md: '50px', lg: '70px' }}>
      <SvgIcon iconName="loading" size={154} />
    </VStack>
  )
}

export default GlobalSpinner
